/**
 * @requires ./frc.js
 * @requires ../vendor/handlebars-latest.js
 * @requires ../vendor/js-cookie.js
 */

frc.utilities = {
	"cache": {
		"init": function(){
			var self = frc.utilities;

			var previousBuildKey = self.cache.get("build-key");
			if(previousBuildKey!=frc.buildKey){
				self.cache.invalidate();
			}
			self.cache.set("build-key", frc.buildKey);
		},
		"get": function(key){
			var ret = null;

			// Get val either from sessionStorage or cookie
			if(window.sessionStorage){
				try {
					ret = window.sessionStorage.getItem(key);
				}catch(err){}
			}
			if(!ret){
				ret = window.Cookies.get(key);
			}

			// Parse if JSON
			try {
				ret = JSON.parse(ret);
			}catch(err){}
			return ret;
		},
		"set": function(key, val, useCookieFallback){
			// Serialize to JSON if object
			if((typeof val)=="object"){
				val = JSON.stringify(val);
			}

			// Store via sessionStorage, and optionally fall back to cookie
			if(window.sessionStorage){
				try {
					return window.sessionStorage.setItem(key, val);
				}catch(err){
					if(useCookieFallback){
						window.Cookies.set(key, val);
					}
				}
			} else if(useCookieFallback && window.Cookies) {
				window.Cookies.set(key, val);
			}
		},
		"invalidate": function(key){
			if(window.sessionStorage){
				try {
					if(key){
						window.sessionStorage.removeItem(key);
					} else {
						window.sessionStorage.clear();
					}
				}catch(err){}
			}
		}
	},
	"geolocate": function(callback){
		if(!callback){
			return;
		}
		if(navigator.geolocation){
			navigator.geolocation.getCurrentPosition(function(pos){
				var ret = {
					'success': true,
					'coords': [
						pos.coords.latitude,
						pos.coords.longitude
					]
				};
				$(frc).trigger("geolocationcomplete", ret);
				callback(ret);
			}, function(){
				callback({
					'success': false
				});
			});
		} else {
			callback({
				'success': false
			});
		}
	},
	"determineNearestLocations": function(callback){

		if(!frc.data.user.geolocation||!frc.data.user.geolocation.coordinates){
			return;
		}

		frc.api.brand.getLocations(function(response){
			if(response && response.data && response.data.length){
				var coords = frc.data.user.geolocation.coordinates;

				var nearestListing = null;
				var nearestOpenTableListing = null;

				response.data.forEach(function(listing){
					if (listing.location.coordinates) {
						listing.distanceMiles = frc.utilities.getDistance(coords[0], coords[1], listing.location.coordinates[0], listing.location.coordinates[1]);

						// All locations
						if(!nearestListing || nearestListing.distanceMiles > listing.distanceMiles){
							nearestListing = listing;
						}

						// OpenTable locations
						if(((typeof listing.location.integrations !== 'undefined') && listing.location.integrations.openTableID) && listing.location.statusIndicationMessage!="coming_soon"){
							if(!nearestOpenTableListing || nearestOpenTableListing.distanceMiles > listing.distanceMiles){
								nearestOpenTableListing = listing;
							}
						}
					}
				});

				var ret = {
					"general": {
						"id": nearestListing.location.id,
						"displayName": nearestListing.location.displayName,
						"distanceMiles": nearestListing.distanceMiles
					}
				};

				if(nearestOpenTableListing){
					ret.openTable = {
						"id": nearestOpenTableListing.location.id,
						"displayName": nearestOpenTableListing.location.displayName,
						"distanceMiles": nearestOpenTableListing.distanceMiles
					}
				}

				callback(ret);
			}
		});
	},
	"getDistance": function(lat1, lon1, lat2, lon2){
		var radlat1 = Math.PI * lat1/180;
		var radlat2 = Math.PI * lat2/180;
		var theta = lon1-lon2;
		var radtheta = Math.PI * theta/180;
		var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
		dist = Math.acos(dist);
		dist = dist * 180/Math.PI;
		dist = dist * 60 * 1.1515;
		return dist;
	},
	"handlebars": {
		"populate": function(templateId, data, $targetElement, append){
			if((typeof $targetElement)=="string"){
				$targetElement = jQuery($targetElement);
			}
			if($targetElement.length===1){
				var source = $('script[data-template-id="' + templateId + '"]').html();
				var template = Handlebars.compile(source);
				var html = template(data);
				if(append){
					$(html).insertAfter($targetElement);
				} else {
					$targetElement.html(html);
				}
			}
		}
	},
	"getUrlParameter": function(name){
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		var results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	},
	"addNavBumper": function(){
		var height = $("header .nav-container .nav-wrapper").outerHeight();

		if ($("header .promo-bar").length) {
			height += $("header .promo-bar").outerHeight();
		}

		if(!$('#nav-bumper').length){
			jQuery("<div></div>").css({
				"display": "block",
				"visibility": "hidden",
				"height": height
			}).attr('id', 'nav-bumper').prependTo("main");
		} else {
			$('#nav-bumper').css('height', height);
		}

		$('header .nav-container').addClass('sticky');
		$(window).trigger('navBumper');
	},
	"anchorScroll": function(strAnchor, intOffset, fncCallback) {
		if (!strAnchor || strAnchor.indexOf('#') < 0) {
			if (window.location.hash.indexOf('#') >= 0) {
				strAnchor = window.location.hash;
			}
		}
		if (!intOffset) {
			intOffset = 0;
		}
		if (strAnchor) {
			$('html, body').animate({scrollTop: ($(strAnchor).offset().top - $('header .nav-container').outerHeight() - intOffset)}, 1000, 'easeInOutCubic', function() {
				if ((typeof fncCallback) === 'function') {
					fncCallback();
				}
			});
		}
	},
	"arrayIntersection": function(){
	  return Array.from(arguments).reduce(function(previous, current){
	    return previous.filter(function(element){
	      return current.indexOf(element) > -1;
	    });
	  });
	},
	"removeArrayKeys": function(associativeArray){
		var ret = [];
		for(var item in associativeArray){
			ret.push(associativeArray[item]);
		}
		return ret;
	},
	"formatDate": function(dateRaw, format){
		var format;
		switch(format){
			case 1:
				// Example: Dec. 1
				format = "MMM. D";
			break;
			case 2:
				// Example: Friday Dec. 4
				format = "dddd MMM. D";
			break;
		}

		var ret = moment(dateRaw);
		ret = (ret.isValid()) ? ret.format(format) : dateRaw;
		return ret;
	},
	"validateForm": function($form, boolInline) {
		if ($('.validation-message').length) { // there can be only one
			$('.validation-message').remove();
		}
	 	var $warning = $("<div class=\"validation-message\" id=\"validation-message\"></div>");

	 	if (!$form[0].checkValidity()) {

	 		var $invalidField = $form.find(':invalid:not(fieldset)').first(),
	 			$parent = $form;

	 		while ($parent.css('position') != 'relative') {
	 			$parent = $parent.parent();
	 		}

	 		var msgX = $invalidField.offset().left - $parent.offset().left,
	 			msgY = $invalidField.offset().top - $parent.offset().top + $invalidField.outerHeight(),
	 			$msg = $('<div class="validation-message-content"></div>'),
	 			isDatepicker = $invalidField.hasClass('hasDatepicker'),
	 			isSelecta = $invalidField.hasClass('selecta-hidden');

	 		$msg.text($invalidField[0].validationMessage).appendTo($warning);

	 		$invalidField.addClass('invalid');

	 		if (isSelecta) {
	 			$invalidField.closest('.selecta').addClass('invalid');
	 		}

	 		if (isDatepicker) {
				$invalidField.closest('div').addClass('invalid');
			}

	 		if (boolInline) {
				var $msgParent = $invalidField.closest('fieldset');
				$warning.appendTo($msgParent).addClass('inline').addClass('active');
			}
			else {
		 		$warning.appendTo($parent).addClass('active').css({
		 			'left': msgX,
		 			'top': msgY,
		 			'z-index': 80
		 		}).fadeIn('fast');

		 		frc.utilities.anchorScroll('#validation-message', $('.nav-container').outerHeight(), function() {
		 			$(window).one('scroll', function() {
						$warning.removeClass('active').fadeOut('fast');
					});
		 		});

		 	}

	 		$invalidField.on('focus selecta-focus change', function() {
	 			$invalidField.removeClass('invalid');

	 			if (isDatepicker) {
	 				$invalidField.closest('div').removeClass('invalid');
	 			}

	 			if (isSelecta) {
		 			$invalidField.closest('.selecta').removeClass('invalid');
		 		}

	 			$warning.removeClass('active').fadeOut('fast');
	 		});

	 		return false;
		}
		else {
			return true;
		}
	},

    /**
     * Determines whether user is viewing website on a mobile device
     * From:
     *     https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
     */
    "isMobileDevice": function() {
        var check = false;

        (function(a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))
            {
                check = true;
            }
        })

        (navigator.userAgent||navigator.vendor||window.opera);

        return check;
    },

	maury: function($baby, $father) {
		var tag = $baby.prop('tagName').toLowerCase();
		while (tag != 'body') {
			if ($baby[0] == $father[0]) { // ARE YOU THE FATHER?
				return true;
				break;
			}
			$baby = $baby.parent();
			tag = $baby.prop('tagName').toLowerCase();
		}
		return false;
	},

	guid: function() {
		function s4() {
			return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
		};

		return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	}
};
